import { Badge, Tooltip } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { CandidateCv } from '../types';
import { CheckIcon, HourglassEmptyIcon, NotInterestedIcon } from 'shared/icons';

const CvStatusBadgeView = ({ status }: { status: CandidateCv['status'] }) => {
   return (
      <Tooltip
         content={
            {
               blocked: 'Заблоковано модератором',
               approved: 'Активне',
               new: 'На модерації',
               modified: 'На модерації',
            }[status]
         }
      >
         {
            {
               approved: (
                  <Badge variant="soft" color="green">
                     <CheckIcon width={24} height={24} />
                  </Badge>
               ),
               blocked: (
                  <Badge variant="soft">
                     <NotInterestedIcon width={24} height={24} />
                  </Badge>
               ),
               new: (
                  <Badge variant="soft">
                     <HourglassEmptyIcon width={24} height={24} />
                  </Badge>
               ),
               modified: (
                  <Badge variant="soft">
                     <HourglassEmptyIcon width={24} height={24} />
                  </Badge>
               ),
            }[status]
         }
      </Tooltip>
   );
};

export const CvStatusBadge = observer(CvStatusBadgeView);
